import { Modal, Spinner } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import Api from "../../Auth/Api";
import { useState } from "react";

function ModalConfirmarAgendamento({ show, onHide, agendamento, onSuccess }) {
    const token = JSON.parse(localStorage.getItem("user_token"));
    const { register, handleSubmit, formState: { errors }, control } = useForm();
    const [isLoading, setIsLoading] = useState(false);

    // Função para formatar data sem problemas de timezone
    const formatDate = (dateString) => {
        if (!dateString) return '';
        // Se a data já vem no formato YYYY-MM-DD, usar diretamente sem conversão de timezone
        if (typeof dateString === 'string' && dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
            const [ano, mes, dia] = dateString.split('-');
            return `${dia}/${mes}/${ano}`;
        }
        // Caso contrário, usar a data normalmente
        const date = new Date(dateString);
        return date.toLocaleDateString('pt-BR');
    };

    // Função para aplicar máscara de CPF
    const maskCPF = (value) => {
        if (!value) return '';
        // Remove tudo que não é dígito
        const numbers = value.replace(/\D/g, '');
        
        // Limita a 11 dígitos
        const limitedNumbers = numbers.slice(0, 11);
        
        // Aplica a máscara
        if (limitedNumbers.length <= 3) {
            return limitedNumbers;
        } else if (limitedNumbers.length <= 6) {
            return `${limitedNumbers.slice(0, 3)}.${limitedNumbers.slice(3)}`;
        } else if (limitedNumbers.length <= 9) {
            return `${limitedNumbers.slice(0, 3)}.${limitedNumbers.slice(3, 6)}.${limitedNumbers.slice(6)}`;
        } else {
            return `${limitedNumbers.slice(0, 3)}.${limitedNumbers.slice(3, 6)}.${limitedNumbers.slice(6, 9)}-${limitedNumbers.slice(9, 11)}`;
        }
    };

    const [showAlerta, setShowAlerta] = useState(false);
    const [mensagemAlerta, setMensagemAlerta] = useState('');

    const onSubmit = async (data) => {
        setIsLoading(true);
        try {
            await Api.post(`/api/agendamentos-treinamentos/${agendamento.id}/confirmar`, data, {
                headers: { Authorization: `Bearer ${token}` }
            });
            onSuccess();
        } catch (error) {
            setMensagemAlerta(error.response?.data?.message || 'Erro ao confirmar agendamento');
            setShowAlerta(true);
        } finally {
            setIsLoading(false);
        }
    };

    if (!agendamento) return null;

    return (
        <>
        <Modal size='lg' show={show} onHide={onHide} backdrop="static">
            <Modal.Header closeButton>
                <span className="fw-semibold fs-5 text-primary">Confirmar Agendamento</span>
            </Modal.Header>
            <Modal.Body className="bg-gray-100 p-4">
                <div className="mb-3">
                    <strong>Treinamento:</strong> {agendamento.nome_curso}<br />
                    <strong>Data:</strong> {formatDate(agendamento.data_treinamento)}<br />
                    <strong>Horário:</strong> {agendamento.hora_treinamento?.substring(0, 5)}<br />
                    <strong>Unidade:</strong> {agendamento.id_unidade}
                </div>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="mb-3">
                        <label className="form-label text-primary fw-medium">Nome do Instrutor</label>
                        <input
                            type="text"
                            className="form-control border-new-light"
                            {...register('nome_instrutor', { required: true })}
                        />
                        {errors.nome_instrutor && <span className="text-danger fs-7">Campo obrigatório.</span>}
                    </div>
                    <div className="mb-3">
                        <label className="form-label text-primary fw-medium">CPF do Instrutor</label>
                        <Controller
                            name="cpf_instrutor"
                            control={control}
                            rules={{ required: true }}
                            render={({ field }) => (
                                <input
                                    type="text"
                                    className="form-control border-new-light"
                                    value={maskCPF(field.value || '')}
                                    onChange={(e) => {
                                        const masked = maskCPF(e.target.value);
                                        // Remove a máscara antes de salvar no form
                                        const unmasked = masked.replace(/\D/g, '');
                                        field.onChange(unmasked);
                                    }}
                                    onBlur={field.onBlur}
                                    placeholder="000.000.000-00"
                                    maxLength={14}
                                />
                            )}
                        />
                        {errors.cpf_instrutor && <span className="text-danger fs-7">Campo obrigatório.</span>}
                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer className="justify-content-end">
                <div className="d-flex justify-content-end">
                    <button 
                        type="button" 
                        className="btn me-2" 
                        onClick={onHide}
                        disabled={isLoading}
                    >
                        Cancelar
                    </button>
                    <button 
                        type="button" 
                        className="btn btn-success"
                        onClick={handleSubmit(onSubmit)}
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <>
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    className="me-2"
                                />
                                Confirmando...
                            </>
                        ) : (
                            'Confirmar'
                        )}
                    </button>
                </div>
            </Modal.Footer>
        </Modal>

        {/* Modal de Alerta */}
        <Modal show={showAlerta} onHide={() => setShowAlerta(false)} centered>
            <Modal.Header closeButton className="border-0">
                <Modal.Title className="text-danger">
                    <i className="bi bi-exclamation-triangle-fill me-2"></i>
                    Erro
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="alert alert-danger mb-0" role="alert">
                    {mensagemAlerta}
                </div>
            </Modal.Body>
            <Modal.Footer className="border-0">
                <button className="btn btn-primary" onClick={() => setShowAlerta(false)}>
                    Entendi
                </button>
            </Modal.Footer>
        </Modal>
        </>
    );
}

export default ModalConfirmarAgendamento;

